/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {NbButtonModule, NbCardModule, NbInputModule, NbWindowRef} from '@nebular/theme';
import {BaseComponent, DamItemVersion, FileService} from 'compob2b-libs';
import {catchError, take} from 'rxjs/operators';
import {translations} from '../../../../../environments/translations.ru';

@Component({
  selector: 'app-dam-item-version-rename',
  templateUrl: './dam-item-versions-rename.component.html',
  styles: `
    input[readonly] {
      background: none !important;
      border: none;
      cursor: default !important;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    NbInputModule,
    NbCardModule,
    NbButtonModule
  ]
})
export class DamItemVersionsRenameComponent extends BaseComponent implements OnInit {

  @Input() version: DamItemVersion;
  form: FormGroup;

  constructor(
    protected readonly fileService: FileService,
    protected readonly windowRef: NbWindowRef,
  ) {
    super();
  }

  ngOnInit(): void {
    let fileName = this.version.header;
    let fileExt = '';

    const lastDotIndex = fileName.lastIndexOf('.');
    if (lastDotIndex > 0) {
      fileExt = fileName.substring(lastDotIndex);
      fileName = fileName.substring(0, lastDotIndex);
    }

    this.form = new FormGroup({
      header: new FormControl(fileName, [Validators.required]),
      fileExt: new FormControl(fileExt),
    });
  }

  onSubmit() {
    if (this.form.valid) {
      this.version.header = this.form.controls['header'].value + this.form.controls['fileExt'].value;

      this.compoApiService
        .post('/dam/rename-version/' + this.version.id, {header: this.version.header})
        .pipe(take(1), catchError(err => this.handleError(err)))
        .subscribe(_ => {
          this.successToast(translations.successfully);
          this.windowRef.close(this.version);
        });
    }
  }

}
